import React from 'react';

import Shimmer from 'components/Shimmer';

import { Container, Filter, Circle, Checkbox } from './styles';

const LoaderDesktop = () => (
  <Container>
    <Filter>
      <Filter.Title>
        <Shimmer>Nombre del hotel</Shimmer>
      </Filter.Title>
      <Filter.Content>
        <Shimmer width="242px" height="48px" />
      </Filter.Content>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Ordenar</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Circle />
          <Shimmer>Recomendado</Shimmer>
        </li>
        <li>
          <Circle />
          <Shimmer>Precio (menor primero)</Shimmer>
        </li>
        <li>
          <Circle />
          <Shimmer>Estrellas (mayor primero)</Shimmer>
        </li>
      </ul>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Precio</Shimmer>
      </Filter.Title>
      <Filter.Content>
        <Shimmer width="242px" height="48px" />
      </Filter.Content>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Politica de cancelacion</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Checkbox />
          <Shimmer>Reembolsable</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>No reembolsable</Shimmer>
        </li>
      </ul>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Estrelas</Shimmer>
      </Filter.Title>
      <ul className="star">
        <li>
          <Shimmer circle={true} width="45px" height="45px" />
        </li>
        <li>
          <Shimmer circle={true} width="45px" height="45px" />
        </li>
        <li>
          <Shimmer circle={true} width="45px" height="45px" />
        </li>
        <li>
          <Shimmer circle={true} width="45px" height="45px" />
        </li>
      </ul>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Ubicación</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Checkbox />
          <Shimmer>Recomendado</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>Precio (menor primero)</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>Estrellas (mayor primero)</Shimmer>
        </li>
      </ul>
    </Filter>
  </Container>
);

export default LoaderDesktop;
